import { Controller } from '@hotwired/stimulus';
import * as basicLightbox from 'basiclightbox';

import 'basiclightbox/dist/basicLightbox.min.css';

export default class extends Controller {
  static targets = ['template', 'opener'];

  connect() {
    this.boundOpen = this.open.bind(this);
    this.boundKeyDown = this.handleKeyDown.bind(this);

    if (this.hasOpenerTarget) {
      // attach to all opener targets
      this.openerTargets.forEach((opener) => opener.addEventListener('click', this.boundOpen));
    }
  }

  disconnect() {
    if (this.hasOpenerTarget) {
      // remove from all opener targets
      this.openerTargets.forEach((opener) => opener.removeEventListener('click', this.boundOpen));
    }

    // cleanup if lightbox is still open
    if (this.instance) {
      document.removeEventListener('keydown', this.boundKeyDown);
    }
  }

  open(event) {
    // ignore ctrl clicks on links
    if (event.metaKey && event.target.tagName === 'A') return;

    event.preventDefault();
    this.instance = basicLightbox.create(this.templateTarget, {
      onClose: () => {
        // cleanup when lightbox closes (via click outside or escape)
        this.cleanup();
      },
    });
    this.instance.show();

    // TODO: remove this custom event listener once lightbox is converted to react
    document.addEventListener('keydown', this.boundKeyDown);
  }

  close() {
    if (this.instance) {
      this.instance.close();
      // cleanup is handled by onClose callback
    }
  }

  cleanup() {
    if (this.instance) {
      this.instance = null;
      document.removeEventListener('keydown', this.boundKeyDown);
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    }
  }
}
